
import React from 'react';
import {DashboardContainer} from "../../funcs/utils";
import {dollarToString} from "../../../lib/currency-utils";
import { sprintf } from "sprintf-js";
import {string_cmp} from "../../../lib/js-utils";
import {AccountTypeLabel} from "../../../lib/constants";
import {MenuButton} from "../../menu/menu-button";
import {HoverOverOp} from "../../menu/common";
import {PopupMenu} from "../../menu/popup-menu";
import {DashboardTable} from "../dashboard-table";

const URL_ROOT = "/wlf-admin";

const STYLE_LUT = (num_rows) => {
  return [
    // Vertical lines
    {
      pred: () => true,
      style: {
        borderLeft: "solid 1px black",
        borderRight: "solid 1px black",
        paddingLeft: "0.3rem",
      }
    },
    // Header top/bottom borders
    {
      pred: (row) => row === 0,
      style: {
        borderTop: "solid 1px black",
        borderBottom: "solid 1px black",
      }
    },
    {
      pred: (row) => row > 0 && row % 2,
      style: {
        backgroundColor: "#EEE",
      }
    },
    {
      pred: (row) => row === 0,
      style: {
        backgroundColor: "#CCC",
      }
    },
    {
      pred: (row) => row === num_rows - 1,
      style: {
        borderBottom: "solid 1px black",
      }
    }
  ]
}


const renderClientCell = (component, item) => {
  const menu_id = sprintf("aum_client_%04d", item.index);
  const client = component.props.client;
  const username = item.username;
  const acct_index = item.acct_index;

  const buttons = username ?
    [ { label: "Dashboard", id: "dashboard" },
      { label: "AUM", id: "aum" } ]
    : [ { label: "AUM", id: "aum" } ];

  const on_click = (menu_id, button_id) => () => {
    component.setState({ [menu_id + "_over"]: false});
    if (button_id === "dashboard") {
      component.props.navigatePath(
        URL_ROOT + "/user",
        { username,
          acct_index });
    } else if (button_id === "aum") {
      const args = {};
      if (username) {
        args.username = username;
        args.acct_index = acct_index;
      }
      component.props.navigatePath(URL_ROOT + "/billing", args);
    }
  }
  const item_style = {
    minWidth: "8rem",
  }
  return (
    <MenuButton
      menu_id={menu_id}
      menu_group_id={"aum_client"}
      label={item.client}
      component={component}
      hoverOverOp={HoverOverOp.DARKEN}>
      <PopupMenu
        component={component}
        backgroundColor={client.color.footer_background}
        color={client.color.footer_primary_text}
        hoverOverOp={HoverOverOp.LIGHTEN}
        onClick={on_click}
        item_style={item_style}
        buttons={buttons}
        menu_id={menu_id}/>
    </MenuButton>
  );
}

const create_table = (items, component, do_fee_table) => {
  const style = {
    width: "100%",
  }
  const cols = do_fee_table
    ? ["Client", "Account", "Account Type", "Total AUM" ]
    : [ "Client", "Account", "Account Type", "Total AUM",
      "Advisor Fee", "Sub Advisor Fee", "Current", "YTD", "Total" ];

  const data = [ cols ];

  if (items) {
    items.forEach(item => {
      if (do_fee_table) {
        data.push([
          renderClientCell(component, item),
          item.account,
          item.account_type,
          item.aum,
        ])
      } else {
        data.push([
          renderClientCell(component, item),
          item.account,
          item.account_type,
          item.aum,
          item.advisor_fee,
          item.sub_advisor_fee,
          item.current,
          item.ytd,
          item.total,
        ])
      }
    })
  }
  return (
    <DashboardTable
      tableStyle={style}
      tdStyleLut={STYLE_LUT(data.length)}
      data={data}
    />);
}

const Clients = props => {

  const component = props.component;
  const do_fee_table = props.do_fee_table;

  return (
    <DashboardContainer
      client={props.client}
      spinner={props.loading}
      title={"Clients"}>
      { create_table(component.state.billing_items, component, do_fee_table)}
    </DashboardContainer>);
}

const gen_wlf = (aum, wlf, index) => {

  const aum_total = wlf.AUM ? wlf.AUM._total : 0.;
  const current = (aum && aum.advisor)
    ? dollarToString((aum.advisor.current - aum.sub_advisor.current) / 100.)
    : "$0";
  const ytd = (aum && aum.advisor)
    ? dollarToString((aum.advisor.ytd - aum.sub_advisor.ytd) / 100.)
    : "$0";
  const total = (aum && aum.advisor)
    ? dollarToString((aum.advisor.total - aum.sub_advisor.total) / 100.)
    : "$0";
  const advisor_fee = wlf.advisory_fee
    ? sprintf("%.1f", wlf.advisory_fee) : "$0.";
  const sub_advisor_fee = wlf.sub_advisory_fee
    ? sprintf("%.1f", wlf.sub_advisory_fee) : "$0.";

  return {
    client: wlf.name,
    aum: dollarToString(aum_total),
    account: "",
    account_type: "",
    advisor_fee,
    sub_advisor_fee,
    current,
    ytd,
    total,
    index,
  }
}

const calc_acct_keys = user => {
  const keys = Object.keys(user).filter(key => key.match(/\d\d\d\d/));
  keys.sort(string_cmp);
  return keys;
}

const gen_user = (user, username, acct_key, month_key, index) => {
  const acct = user[acct_key];
  let aum;
  if (acct.aum && acct.aum.month && month_key in acct.aum.month) {
    aum = acct.aum.month[month_key];
  } else {
    //console.log("acct", acct, "no AUM");
  }

  let current, ytd, total;

  if (aum) {
    current = dollarToString((aum.advisor.current - aum.sub_advisor.current) / 100.);
    ytd = dollarToString((aum.advisor.ytd - aum.sub_advisor.ytd) / 100.);
    total = dollarToString((aum.advisor.total - aum.sub_advisor.total) / 100.);
  } else {
    current = "UNDEFINED";
    ytd = "UNDEFINED";
    total = "UNDEFINED";
  }

  return {
    client: user.name,
    aum: dollarToString(acct.aum_usd),
    account: acct.tda_account_number,
    account_type: AccountTypeLabel(acct.account_type),
    advisor_fee: sprintf("%.1f", acct.advisory_fee || 0),
    sub_advisor_fee: sprintf("%.1f", acct.sub_advisory_fee || 0),
    current,
    ytd,
    total,
    index,
    username,
    acct_index: parseInt(acct_key, 10),
  }
}

/**
 * Generate items of the form:
 * {
 *   client: {str}
 *   aum: {str}
 *   account: {str}
 *   account_type: {str}
 *   advisor_fee: {str}
 *   sub_advisor_fee: {str}
 *   current: {str}
 *   ytd: {str}
 *   total: {str}
 * }
 */
const generate_aum_items = (aum_result, wlf) => {

  const result = [];

  if (aum_result.wlf) {
    const aum = aum_result.wlf.month[aum_result.display_month];
    result.push(gen_wlf(aum, wlf, 0));
  }
  let usernames = Object.keys(aum_result.users);
  usernames.sort(string_cmp);
  usernames.forEach(username => {
    const user = aum_result.users[username];
    const keys = calc_acct_keys(user);
    keys.forEach(key => {
      result.push(gen_user(user, username, key, aum_result.display_month, result.length));
    })
  })

  return result;

}

const initState = () => {
  return {
    aum_wlf: null,
    aum_users: null,
  };
}

export { initState, Clients, generate_aum_items };
